import { render, staticRenderFns } from "./PesananPengiriman.vue?vue&type=template&id=b211613e&scoped=true&"
import script from "./PesananPengiriman.vue?vue&type=script&lang=js&"
export * from "./PesananPengiriman.vue?vue&type=script&lang=js&"
import style0 from "./PesananPengiriman.vue?vue&type=style&index=0&id=b211613e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b211613e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/Project/Gitpanda/Agroforestcape/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VContainer,VDataTable,VDivider,VFlex,VIcon,VLayout,VList,VTextField,VToolbar})
